namespace Areas.Dialogs.TimeEntry {
    "use strict";

    let employeeId: number;
    let accountId: number;
    let accountWorkOrderId: number;
    let overtimeType: string;
    let taskCodeLk: string;
    let correctiveEntryRefId: number;
    let usageDate: Date;
    let runQuery: boolean = false;

    export function getEmployeeId() {
        return employeeId;
    }

    export function getAccountId() {
        return accountId;
    }

    export function getAccountWorkOrderId() {
        return accountWorkOrderId;
    }

    export function getOvertimeType() {
        return overtimeType;
    }
    
    export function getTaskCodeLk() {
        return taskCodeLk;
    } 

    export function getCorrectiveEntryRefId() {
        return correctiveEntryRefId;
    }

    export function getUsageDate() {
        return moment(usageDate).format('YYYY-MM-DD');
    }

    export function canExecuteQuery() {
        return runQuery;
    }

    export class TimeEntryDialog extends Areas.BaseDialog {
        constructor(closeHandler: (dialogResult: DialogResult, data: any) => void, parameters: any = null) {
            super("TimeEntry", closeHandler, parameters, () => {
                employeeId = parameters.key.employeeId; 
                accountId = parameters.key.accountId;
                accountWorkOrderId = parameters.key.accountWorkOrderId;
                overtimeType = parameters.key.overtimeType;
                taskCodeLk = parameters.key.taskCodeLk;
                correctiveEntryRefId = parameters.key.correctiveEntryRefId;
                usageDate = parameters.usageDate;
                const grid = $("#TimeEntryGrid").dxDataGrid("instance");
                
                runQuery = true;
                grid.refresh();
            });
        }

        protected ok = (e: any) => {
           this.close(DialogResult.Ok, null); 
        }
    }

    export function beforeSend(operation, ajaxSettings) {

        if (operation === 'insert') {
            let data = JSON.parse(ajaxSettings.data.values);

            data.employeeId = employeeId;
            data.accountId = accountId;
            data.accountWorkOrderId = accountWorkOrderId;
            data.overtimeType = overtimeType;
            data.taskCodeLk = taskCodeLk;
            data.correctiveEntryRefId = correctiveEntryRefId;
            data.usageDate = getUsageDate();
            ajaxSettings.data.values = JSON.stringify(data);
        }
    }


}
